export default {
    startPage: {
        title: 'Vue 学习'
    },
    menu: {
        Documents: 'Sports Archives',
        Setting: 'System Setup',
        Applications: "Applications",
        Report: "Data Report",
        AthleteDocuments: "Athlete",
        SportProject: "Sport Project",
        Options: "Options",
        Permission: "Permission",
        StandardData: "cha.Val Mgmt",
        MuscleStrengthStandard: 'Portable Muscle Strength Reference Values',
        //SportsPerformanceStandardData:'运动功能表现参考值',
        UserManagement: "User Management",
        Subject: "Details of athletes",
        Record: "Records",
        Result: "Test Result",
        Actions: "Action Datas",
        SportsPerformanceStandardData: 'Sports Performance',
        MuscleStrengthStandardData: 'Muscle Strength'
    },
    userMenu: {
        confirmExit: 'Logout',
        confirmMsg: 'Are you sure you want to logout?',
        DarkMode: 'Dark Mode',
        Modify: 'Modify',
        Account: 'Account',
        UserName: 'UserName',
    },
    options: {
        Title: 'Preference setting',
        Language: 'language',
        ModifyNotice: 'Modified successfully',
        ModifyNotice2: 'Modification failure',
        SystemSettings: 'Basic Setting',
        AccountSetting: 'Account Setting',
        Account: 'Account',
        OrganizationInfo: 'Organization Information',
        CompanyName: 'Company Name:',
        CompanyCode: 'Company Code:',
        CustomLogo: 'Custom Logo',
        Name: 'Name',
        Preview: 'Preview',
        UploadPictures: 'Click to upload the picture',
        Notice1: 'The best size of the picture is 48px in height, less than 200px in width, and less than 1MB in PNG or jpg format.',
        ModifyPassword: 'Modify password',
        confirmExit: 'Log out',
        ModifyName: 'Change the name',
        notice2: 'Name modified successfully',
        notice3: 'Please enter a name',
        Lable: {
            Multilingual: 'Multilingual',
            Logo: 'Custom Logo',
        }
    },
    login: {
        Label: {
            UserName: 'UserName',
            Password: 'Password',
            Login: 'Login',
            Reset: 'Reset',
            Title: 'Please login',
            Title2: 'Register',
            Forget: 'Forget the password?',
            Remember: 'Remember the password',
            Register: 'To register>>',
            ToLogin: 'Already have an account,go to login>>',
            Captche: 'Access authentication code',
            Retry: 'Re-acquisition',
            Agree: 'I Agree 《User Agreement》',
            UserNamePlaceholde: 'Please enter a username',
            PasswordPlaceholde: 'Enter your password',
            CompanyCodePlaceholder: 'Company Code',
            MailBoxPlaceHolder: 'Please enter your mailbox',
            CaptchaPlaceholder: 'Mailbox verification code'
        },
        Message: {
            PasswordLength: 'The password is between 8 and 16 characters in length',
            CaptchaSuccess: 'Send successfully',
            Agree: 'Please read and check 《User Agreement》',
            AccountEmpty: 'Please fill in the mailbox correctly',
            Registered: 'Registered successfully',
            loginFaild: "Login falid!",
            Captcha: 'The length of the verification code is insufficient',
            CompanyCodeLength: 'Please enter the correct company code',
            CaptchaLenthL: 'Please enter the complete Captcha',
        }
    },
    forget: {
        Label: {
            Title: 'Retrieve the password',
            GoToLogin: 'Go to login >>',
            Captche: 'Access authentication code',
            Reset: 'Reset password',
            Retry: 'Re-acquisition',
            Contact: 'If this page cannot be solved, please contact customer service.',
            AccountPlaceholder: 'Please enter the email address which you registered',
            CaptchaPlaceholder: 'Mailbox verification code',
            PasswordPlaceholder: 'New Password',
            ModifyPassword: 'Modify Password',
        },
        Message: {
            CaptchaSuccess: 'Sent successfully',
            ResetSuccess: 'Reset password successfully',
            AccountEmpty: 'Please fill in the mailbox correctly',
        }
    },
    global: {
        HomePage: 'Home Page',
        Loading: 'Loading',
        CopySuccess: 'Copy success',
        CopyFailed: 'Copy failed',
        Refresh: 'Refresh',
        Add: 'Add',
        Create: 'Create',
        Modify: 'Modify',
        Confirm: 'Confirm',
        Cancel: 'Cancel',
        Save: 'Save',
        View: "View",
        Edit: "Edit",
        Delete: "Delete",
        Finish: "Finish",
        LastWeek: "Last Week",
        LastMonth: "Last Month",
        Last3Month: "Last 3 Month",
        StartDate: "Start Date",
        EndDate: "End Date",
        TestProject: "Test Project",
        SportProject: "Sport Project",
        None: "No Limit",
        Gender: "Gender",
        RequestFailed: 'Request failed!',
        ResponseFailed: 'Failed to return the request!',
        LoadSuccess: 'Download succeeded',
        LoadFailed: 'Download failed',
        EditRelation: 'Editing motion relationship',
        EditSubject: 'Edit athlete information',
        EditProject: 'Edit sports project',
        Import: 'Import',
        Export: 'Export',
        NoneData: 'No data yet',
        NoneRank: 'There is no ranking',
        SaveSuccess: "Save successfully",
        Checked: 'Checked',
        Close: 'Close'
    },
    Permission: {
        Label: {
            Title: "Permission Management",
            Enable: "Enable",
            Description: 'Description',
            ExpireDate: 'Expire Date',
            CreateGroup: "Create Group",
            GroupRole: "Role",
            GroupName: "Name",
            SelectRoleType: "Select Role",
        },
        Message: {
            GetGroupsFailed: "Get groups failed",
            GetApplicationListFailed: 'Get application list failed',
            ChangeUnsaved: "Have unsaved changes, are you sure you want to leave?",
            ComfirmToDelete: "Are you sure you want to delete this group?",
            DeleteSuccess: 'The deletion is successful',
        }
    },
    Documents: {
        Lable: {
            ViewPersonDocument: 'View personal profiles',
            InvationInfo: 'Invite users to register',
            DeleteInvation: 'Delete the invitation',
            ViewHistoryRecords: 'View history',
            ViewDetailRecords: 'View record details',
            TestDetialExport: 'Export record details',
            ViewActionDetail: 'View the action details',
            ActionDataExport: 'Action data export',
        },
        HomePage: 'Home page',
        Reinvite: 'Re-invite',
        SportDocuments: 'Sports file',
        RegisterSubject: {
            Title: 'You are invited to complete your profile',
            Save: 'Submit',
            From: 'From',
            Invitation: 'invitation',
            PlaseEnter: 'Please enter',
        },
        Athletes: {
            TotalCount: 'Total',
            TotalProjects: 'projects',
            DeleteNotice: 'Are you sure you want to delete an athlete from an info-fill invitation?',
            ProjectNameSearch: 'Sport name search is supported',
            selectDate: 'Select date',
            CreateTime: 'Creation time',
            ClickShow: 'Click to expand',
            ClickPutaway: 'Click to put away',
            FormarErrorNotice: '(Note: it can be retained to at most one decimal place.)',
            EmailNoticeLogin: 'Mailbox (can be used to log in)',
            LoginEmail: 'Can be used to log in',
            Athletes: 'Athletes',
            MultipleSelection: 'Multiple selection',
            true: 'Multiple selection',
            false: 'Complete',
            AddDocuments: 'Add archiv',
            TestSystem: 'Test system radio',
            Nodata: 'No data',
            SportFunction: 'Motor function performance test system',
            DigitalRunway: 'Digital runway data acquisition and analysis software',
            MuscleStrength: 'Muscle strength testing system',
            GolfTechnique: 'Golf technique diagnosis',
            Screening: 'Screening',
            GenderLimit: 'Gender is not limited',
            SystemLimit: 'The system is unlimited',
            TestProject: 'Test project',
            Photo: 'Photo',
            NextPage: 'Next page',
            PreviousPage: 'Previous page',
            Age: 'age',
            View: 'View',
            EditingData: 'Editing data',
            HistoricalRecord: 'Historical record',
            SkipPages: 'Skip pages',
            AddTestProject: '+Add to test project',
            AssociationSportProject: '+Associated sports',
            DeldeteDocument: 'Delete file',
            Complete: 'Complete',
            SearchNotice: 'Name search is supported',
            CreateSubject: 'Add new files',
            ModifySubject: 'Modify the file',
            AddRelationSuccessNotice: 'Add association successfully',
            AddRelationFailNotice: 'Failed to add association',
            AddRelationNotice: 'Please select a project to associate with',
            BaseInfo: 'Basic information',
            InviteUsersRegister: 'Invite users to register',
            Save: 'Save',
            Total: 'A total of',
            Projects: 'all projects are currently complete',
            Picture: 'Photo',
            PhotoLimitNotice: '',
            PhotoLimitNotice2: 'Please upload photos with a size of less than 1Mb',
            Name: 'Name',
            EnterNotice: 'Please enter athlete name',
            Gneder: 'Gender',
            Birthday: 'Birthday',
            Height: 'Height',
            Weight: 'weight',
            EnterWeightNotice: 'Please enter the weight of the athlete',
            EnterHeightNotice: 'Please enter the height of the athlete',
            PhoneNumber: 'Phone number',
            EnterPhoneNumberNotice: 'Please enter phone number',
            RequiredNotice: 'Cannot be empty',
            PhoneNumberNotice: 'Please enter the correct number format',
            Email: 'E-mail',
            EnterEmailNotice: 'Please enter your email address',
            EmailNotice: 'Please enter the correct mailbox format',
            PictureFileNotice: 'Please select the correct picture file',
            PictureSizeNotice: 'Please select a picture less than 1Mb',
            Manage: 'Manage',
            Add: '+ Add',
            Years: 'years old',
            FormarError: 'Incorrect data format',
            ViewDocument: 'View Archiv',
            AddToProject: 'Add To Project',
            Record: 'Record',
            LoadAll: 'All resources loaded',
            Reset: 'Reset',
            Invationing: 'Invitation history',
            BatchExportIndicator:'Batch export indicators',
            Link: {
                Invitation: 'Invite users to register',
                FileName: 'File name',
                LoginEmail: 'Register mailbox',
                InvitationLink: 'Invitation link',
                SendInvitation: 'Send invitation',
                CopyLink: 'Copy link',
                LinkNotice: 'Only when the user submits the data can the file be created',
                InvitationOther: 'Invite others',
                Notice: 'Copy successfully',
                Notice2: 'Replication failed',
                Notice3: 'Invitation sent successfully',
                Notice4: 'Failed to send invitation',
                InvationNotice: 'After entering the athlete name and clicking the build link, the invitation link will be sent directly to the filled mailbox',
                Notice5: 'Please enter the athlete name',
            },
            Details: {
                RelationToProject: 'Add to project',
                ModifySocument: 'Modify the data',
                RelationRecord: 'Related record',
                None: 'None',
                SwingSide: 'Batter',
                PowerLeg: 'Force leg',
                LeftHand: 'Left hand',
                RightHand: 'Right hand',
                LeftLeg: 'Left leg',
                RightLeg: 'Right leg',
                Left: 'Left',
                Right: 'Right',
                LeftRight: 'Left and right',
                ShoeSize: 'Shoe size',
                Statistics: 'Data statistics',
                ClickNotice: 'Click actions or numbers to view details',
                Unit: {
                    SwingSide: 'hand',
                    PowerLeg: 'leg',
                    ShoeSize: 'size',
                }
            },
            TestRecord: {
                TestRecord: 'Test record',
                StartDate: 'Start date',
                EndDate: 'End date',
                SelectNotice: 'Please select the test system first',
                Time: 'time',
                None: 'None',
                DataLength: 'record',
            },
            Result: {
                Application8: {
                    'Swing': 'Swing',
                    'Akimbo': 'Akimbo',
                    'Other': 'Other',
                    'Bilateral': 'Bilateral',
                    'Left': 'Left',
                    'Right': 'Right',
                    'MidThighPull': 'Hard Mid-Thigh Pull',
                    '1_4Squat': 'A Quarter Squat',
                    'CalfRaise': 'Calf Raise',
                    'Customization': 'Customization',
                    'ITest': 'I Test',
                    'YTest': 'Y Test',
                    'TTest': 'T Test',
                    'FreeMode': 'Free mode',
                    'TimekeepingMode': 'Timekeeping Mode',
                    'UpperLimbs': 'Upper limbs',
                    'LowerLimbs': 'Lower limbs',
                    '动作开始': 'Action Start',
                    '峰值': 'Peak',
                    '离地': 'Off The Ground',
                    '落地': 'Landing',
                    '开始': 'Began',
                    '制动': 'Braking',
                    '最低点': 'Nadir',
                    '落地峰值': 'Landing peak',
                    '动作结束': 'Action End',
                    '跌落峰值': 'Drop peak',
                    '蹬伸峰值': 'Pedal peak',
                    '左侧最大力值': 'Left Side Max Force',
                    '右侧最大力值': 'Right Side Max Force',
                    '50ms': '50ms',
                    '100ms': '100ms',
                    '150ms': '150ms',
                    '200ms': '200ms',
                    '250ms': '250ms',
                    '300ms': '300ms',
                    'TFmin': 'TFmin',
                    'T1': 'T1',
                    'TStart': 'TStart',
                    'TEnd': 'TEnd',
                    'PO': 'PO',
                    '触地': 'Touchdown',
                    '稳定': 'Stable',
                    '最大垂直力值': 'Maximum Vertical Force',
                    'A': 'A',
                    'B': 'B',
                    'C': 'C',
                    'D': 'D',
                    'E': 'E',
                    '制动时刻': 'Braking Time',
                    '起跳时刻': 'Jump Time',
                    'Remark': 'Remark',
                    '蹬伸': 'Pedal',
                    '结束': 'End',
                    '力':'Force',
                    '时间':'Time',
                    '速度/加速度':'Velocity/Acceleration',
                    '功率':'Power',
                    '位移':'Displacement',
                    '其他':'Other',
                    '冲量':'Impulse',
                    '频率':'Frequency',
                    '':''
                },
                SendNotice: 'Please select the content to send',
                SendSuccessfully: 'Send successfully',
                EmailContent: 'Email content',
                SendEmail: 'Send Email',
                ReceivingEmail: 'Receiving email',
                COPPosition: 'COP',
                ModelSetting: 'Test Module',
                ModelType: 'Test Module',
                L_Fz_COP: 'L-COP in line',
                R_Fz_COP: 'R-COP in line',
                Fz_COP: 'Merge-COP in line',
                Left: 'Left',
                Right: 'Right',
                Fz: 'Merge',
                COP: 'COP View',
                AllFz: 'Merge-Fz',
                Legend: 'Legend',
                Asi: 'Asymmetry Indicator',
                LeftRightRatio: 'Left-right Ratio',
                HistoryMax: 'All-time high',
                Now: 'Current',
                MainIndicators: 'Main indicators',
                OtherIndicators: 'More indicators',
                ExtendedIndicators: 'Expand metrics',
                SingleView: 'Single indicators',
                NumberOfTimes: 'Number of times ',
                NoData: 'Unsaved data',
                GoBack: 'Back',
                RawData: "Download Raw Data",
                Export: 'Export Indicators',
                Weight: 'Test body weight',
                Duration: 'Test time',
                GolfClubs: 'Use the club',
                Spacing: 'Standing posture distance',
                LeftAngle: 'Left deviation angle',
                RightAngle: 'Right deviation angle',
                LeftLeg: 'Left leg',
                RightLeg: 'Right leg',
                ResultantForce: 'Merge',
                Limbs: 'Limbs',
                Side: 'Side',
                Actions: 'Actions',
                Pose: 'Pose',
                Order: 'Sequence',
                Joint:'Joint',
                KneePosition: 'Knee position',
                Times_L: 'Left-foot count',
                Times_R: 'Right-foot count',
                0: 'Default',
                1: 'Left side',
                2: 'right side',
                3: 'First left then right',
                4: 'First right then left',
                Unit: {
                    KneePosition: 'CM',
                    Times_L: '',
                    Times_R: '',
                    Spacing: 'CM',
                    Weight: 'KG',
                    Duration: 'S',
                    LeftAngle: '°',
                    RightAngle: '°'
                },
                OnceHeader: 'Times T ',
                ExportReport: 'Export Report',
                Repetitions: 'Repetitions',
                ContainsPersonalRecords: 'Contains personal records',
                MuscleStrengthAvgIndicator: {
                    最大峰值力: 'Maximum peak force',
                    平均峰值力: 'Average peak force',
                    到达峰值时间: 'Peak time',
                    峰值发力率: 'Peak force rate',
                    峰值力: 'Peak force'
                },
                '左侧最大范围':'Maximum range on the left',
                '左侧最大范围时间':'Maximum range time on the left',
                '右侧最大范围':'Maximum range on the right',
                '右侧最大范围时间':'Maximum range time on the right',
                '左侧平均范围':'Left average range',
                '最大范围BSA':'Maximum range BSA',
                '右侧平均范围':'Right average range',
                '最大范围':'Maximum range',
                '平均范围':'average range',
                '最大范围时间':'Maximum range time',
                Times: 'Times',
                NumberOfTests:'Number of tests',
                LeftSide:'Left side',
                RightSide:'Right side',
                数值:"Numerical",
                ReferenceValue: 'Reference value',
                Internal: 'Internal rotation',
                External: 'External rotation',
                Adduction: 'Adduction',
                Abduction: 'Outreach',
                Varus: 'Inversion',
                Valgus: 'Eversion',
                MaximumForceRatio: 'Maximum force ratio',
                AvgForce: 'Peak force average',
                MaxForce: 'Peak force maximum',
                MaxImpulse: 'Maximum impulse',
                AvgImpulse: 'Average impulse',
                AvgForce_Baseline: 'Peak force average(Baseline value)',
                MaxForce_Baseline: 'Peak force maximum(Baseline value)',
                MaxImpulse_Baseline: 'Maximum impulse(Baseline value)',
                AvgImpulse_Baseline: 'Average impulse(Baseline value)',
            },
            Action: {
                Action: 'Action data',
                TrendChart: 'Trend chart',
                IndexNotice: 'Please select the metrics to view',
                RelationRecord: 'Related record',
                Delete: 'Delete',
                Export: 'Export selected record',
                None: 'None',
                ExportData: 'Export raw data',
                ExportData1: 'Export data',
                EcportIndex: 'Export Indicator',
                ExportReport: 'Export report',
                C3DReport: 'Export C3D',
                ViewRecord: 'View record',
                Index: 'Indicator',
                Report: 'Report',
                Data: 'Raw data',
                Total: 'Total',
                Datas: 'pieces of data',
                Max: 'Max',
                Min: 'Min',
                Notice: 'Please select a record first',
                NoIndex: 'No indicators',
            },
            SingleCreate: 'Manual Add',
            DownloadTemplate: 'Download Template',
            SubjectImportTemplate:"Subject Import Template",
            ImportFromTemplate: 'Batch Import by Template',
            Template: 'Athlete Batch Import Template',
            Upload: "Import",
            ImportSuccess: 'Import Success',
            ImportFailed: 'Import Failed',
            Items: 'Items'
        },
        SportProjects: {
            SportProjects: 'Sport projects',
            AddSportProjectNotice: 'Sports are only used to distinguish athletes',
            ProjectName: 'Project name',
            AddProject: 'Add project',
            RelatedCount: 'Related number of people',
            Operate: 'Operate',
            RelatedAthletes: 'Related athletes',
            AddSportProject: 'Add a sports project',
            notice1: 'Choose at least one',
            SelectApplications: 'Application system',
            ProNameNotice: 'Enter the sports item name',
            addSuccessNotice: 'Sports items added successfully',
            ddFaildNotice: 'Failed to add a sport item',
            deleteSuccessNotice: 'Sports item deleted successfully',
            deleteFaildNotice: 'Failed to delete sports item',
            updateSuccessNotice: 'The motion item was modified successfully',
            updateFaildNotice: 'Motion item modification failed',
            CreateSportProject: 'Create a sports project',
            EmptyNotice: 'Please enter a project name',
            People: 'peolpe',
            Name: 'Name',
            Gender: 'Gender',
            Birthday: 'Birthday',
            ModifyName: 'Modify',
            ModifySportProject: 'Modify a sports item',
            modifySuccessNotice: 'Project name modified successfully',
            modifyFaildNotice: 'Project name cannot be duplicated',
            AddSport: 'Manage athletes',
            Athletes: 'Athletes',
            QueryError: 'Query failed',
            Added: 'Added',
            SaveFailNotice: 'Failed to save',
            SaveSuccessNotice: 'Saved successfully',
            NotSaved: 'The content has not been saved, do you want to leave?',
            DeleteNotice: 'Are you sure you want to delete this sport?',
            Notice: 'Notice',
            DeleteProjcctNotice: 'Delete a sports item',
        }
    },
    Application: {
        Name: {
            1: 'Muscle Strength Testing System',
            5: 'Golf Technical Diagnostic System',
            6: 'Hamstring Test System',
            7: 'Multi-functional force measuring frame',
            8: 'Sports Performance Measurement System',
            9: 'Range of motion'
        },
        Label: {
            Detail: "Detail",
            SubjectCount: 'Athletes',
            RecordCount: 'Records',
            ProjectCount: 'Projects',
            RankList: "Rank",
            More: "More>",
            TrendCharts: "Charts",
            Indicators: "Indicators",
            ExportIndicators: "Export Indicators",
            TrainingPlan: 'Training Plan',
            MostRecentRecord:'Most Recent Record',
            AllRecords:'All Records'
        },
        Options: {
            LastDays: "Last %d days"
        },
        Columns: {
            CreateTime: "Create Time"
        },
    },
    Report: {
        Label: {
            MinAvgMax: "Min/Max",
            ReportChart: "Report Chart",
            Query: "Query",
            Export: "Export",
            IndicatorOptions: "Indicator Filter",
            SubjectOptions: "Select Athletes",
            MaxValue: "Take the maximum value",
            MinValue: "Take the minimum value",
            InsertChart: "Insert Chart",
            ModifyChart: "Modify Chart",
            true: 'MaxValue',
            false: 'MinValue',
            指标:'Indicator',
            值:'Value',
            单位:'Unit'
        },
        Message: {
            IndicatorsEmpty: "Please select an indicator",
            SubjectEmpty: "Please select an athlete"
        },
        Indicators: {
            峰值: 'Peak',
            峰值时间: 'Peak time',
            最大发力率: 'Max force rate',
            最大峰值力:'Maximum peak force',
            平均峰值力:'Average peak force',
            到达峰值时间:'Peak time',
            峰值发力率:'Peak force rate',
            左脚平均峰值力: 'Average peak left foot force',
            右脚平均峰值力: 'Average peak force on the right foot',
            左脚最大力值: 'Maximum left foot force',
            右脚最大力值: 'Maximum right foot force',
            左脚重复次数: 'Number of repetition on left foot',
            右脚重复次数: 'Number of repetition on right foot',
            左重复次数: 'Left repetition',
            右重复次数: 'Right repetition',
            内收左重复次数: 'Number of repetitions of the left',
            内收右重复次数: 'Number of repetitions of the right',
            外展左重复次数: 'Abduct left repetitions',
            外展右重复次数: 'Abduct right repetitions',
            内旋左重复次数: 'Number of repetitions of left pronation',
            内旋右重复次数: 'Number of repetitions of right pronation',
            外旋左重复次数: 'Number of repetitions of left rotation',
            外旋右重复次数: 'Number of repetitions of right rotation',
            内翻左重复次数: 'Number of repetitions of left pronation',
            内翻右重复次数: 'Number of repetitions of right pronation',
            外翻左重复次数: 'Number of repetitions of left valgus',
            外翻右重复次数: 'Number of repetitions of right valgus',
            左最大力值: 'Left maximum force value',
            右最大力值: 'Right maximum force value',
            内收左最大力值: 'Maximum adduction left force value',
            内收右最大力值: 'Maximum adduction right force value',
            外展左最大力值: 'Abductive left maximum force value',
            外展右最大力值: 'Abductive right maximum force value',
            内旋左最大力值: 'Maximum internal left force value',
            内旋右最大力值: 'Maximum internal right force value',
            外旋左最大力值: 'Maximum outside-left force value',
            外旋右最大力值: 'Maximum outside-right force value',
            内翻左最大力值: 'Maximum left force value of inversion',
            内翻右最大力值: 'Maximum right force value of inversion',
            外翻左最大力值: 'Valgus left maximum force value',
            外翻右最大力值: 'Valgus right maximum force value',
            左脚扭矩: 'Left foot torque',
            右脚扭矩: 'Right foot torque',
            左脚峰值力最大值: 'Maximum left foot peak force',
            右脚峰值力最大值: 'Maximum peak force right foot',
            峰值力最大值BSA: 'Peak force maximum BSA',
            左脚峰值力平均值: 'Left foot peak force average',
            右脚峰值力平均值: 'Average right foot peak force',
            峰值力平均值BSA: 'Peak force average BSA',
            左脚冲量平均值: 'Left foot impulse average',
            右脚冲量平均值: 'Average right foot impulse',
            冲量平均值BSA: 'Impulse Average BSA',
            左脚冲量最大值: 'Maximum left foot impulse',
            右脚冲量最大值: 'Maximum right foot impulse',
            冲量最大值BSA: 'Maximum impulse BSA',
            '最大相对力值': 'Maximum Relative Force Value',
            '合力最大力值': 'Resultant Maximum Force Value',
            '左侧最大力值': 'Left Maximum Force Value',
            '右侧最大力值': 'Right Maximum Force Value',
            '平均功率': 'Average Power',
            '相对平均功率': 'Relative Average Power',
            '峰值功率': 'Peak Power',
            '相对峰值功率': 'Relative Peak Power',
            '峰值功率发生时刻': 'Peak Power Occurrence Time',
            '峰值功率发生时速度': 'Velocity at Peak Power Occurrence',
            '向心阶段冲量': 'Concentric Phase Impulse',
            '向心最大速度': 'Maximum Concentric Velocity',
            '缓冲最小相对力值': 'Minimum Relative Force Value (Buffer)',
            '峰值力发力率': 'Rate of Force Development (RFD)',
            '起跳速度': 'Takeoff Velocity',
            '腾空时间': 'Flight Time',
            '腾空高度v': 'Height(v)',
            '腾空高度Ft': 'Height(Ft)',
            '腾空高度t': 'Height(t)',
            '下蹲时间': 'Squat Time',
            '制动时间': 'Braking Time',
            '蹬伸时间': 'Pedal Time',
            '触地时间': 'Touch Time',
            '反应力量指数RSI': 'RSI',
            '反应力量指数RSImod': 'RSImod',
            '蹬伸与制动时间比T': 'Redal To Braking Time Ratio',
            '蹬伸最大功率%': 'Pedal Max Power%',
            '蹬伸最大力值%': 'Pedal Max Force%',
            '落地最大力值':'Touch Max Force',
            '落地最大力值%': 'Touch Max Force%',
            '合力最大力值DSI': 'Max Force DSI',
            '左侧最大力值DSI': 'Left Side Max Force DSI',
            '右侧最大力值DSI': 'Right Side Max Force DSI',
            '腾空高度EUR': 'Height(EUR)',
            '最大蹬伸力发力率': 'Max Pedal Force Rate',
            '跌落相对峰值力': 'Drop Relative Peak Force',
            '蹬伸相对峰值力': 'Pedal Relative Peak Force',
            '蹬伸相对最大功率': 'Pedal Relative Max Power',
            '腾空速度': 'Free Up Speed',
            '蹬伸峰值加速度': 'Pedal Peak Acceleration',
            '跌落峰值%': 'Drop Peak%',
            '跌落峰值加载率%': 'Drop Peak Loading Rate%',
            '蹬伸峰值%': 'Pedal Peak%',
            '蹬伸峰值加载率%': 'Pedal Peak Loading Rate%',
            '相对最大力值': 'Relative Max Force',
            '到达最大力值时间': 'Reach Maximum Force Time',
            '左侧到达最大力值时间': 'Left Side Reach Maximum Force Time',
            '右侧到达最大力值时间': 'Right Side Reach Maximum Force Time',
            '50ms冲量': '50ms Impulse',
            '100ms冲量': '100ms Impulse',
            '150ms冲量': '150ms Impulse',
            '200ms冲量': '200ms Impulse',
            '250ms冲量': '250ms Impulse',
            '300ms冲量': '300ms Impulse',
            '50ms RFD': '50ms RFD',
            '100ms RFD': '100ms RFD',
            '150ms RFD': '150ms RFD',
            '200ms RFD': '200ms RFD',
            '250ms RFD': '250ms RFD',
            '300ms RFD': '300ms RFD',
            '最大合力时刻分量%': 'Max Resultant Moment Component%',
            '最大力值%': 'Max Force%',
            '最大力值时间%': 'Max Force Time%',
            '单位体重最大力值': 'Maximum Force Per Unit Weight',
            '平均缓冲最大相对力值': 'Avg Buffer Max Relative Force',
            '平均蹬伸最大相对力值': 'Avg Pedal Max Relative Force',
            '平均缓冲时间': 'Avg Buffer Time',
            '平均蹬伸时间': 'Avg Pedal Time',
            '平均触地时间': 'Avg Touch Time',
            '平均腾空时间': 'Avg Vacancy Time',
            '平均腾空高度': 'Avg Vacancy Height',
            '平均反应力量指数RSI': 'Avg RSI',
            '平均反应力量指数RSImod': 'Avg RSImod',
            '蹬伸平均最大力值%': 'Pedal Average Max Force%',
            '缓冲平均最大力值%': 'Buffer Avg Max Force%',
            '缓冲加载率%': 'Buffer Load Rate%',
            '平均起跳速度': 'Avg Take-Off Speed',
            '平均峰值功率': 'Avg Peak Power',
            '蹲起时间': 'Squat Up Time',
            '绝对最大力值': 'Absolute Max Force',
            '缓冲相对最大力值': 'Buffer Relative Max Force',
            '缓冲相对最小力值': 'Buffer Relative Min Force',
            '蹬伸相对最大力值': 'Pedal Relative Max Force',
            '相对最大功率': 'Relative Max Power',
            '下蹲和蹬伸时间比': 'Squat And Pedal Ratio',
            '相对最大力值%': 'Relative Max Force%',
            '相对最大功率%': 'Relative Max Power%',
            '总计次数': 'Total Times',
            '频率': 'Frequency',
            '初段平均频率': 'Initial Average Frequency',
            '中段平均频率': 'Middle Average Frequency',
            '末段平均频率': 'End Segment Average Frequency',
            '耐力指数': 'Endurance',
            '疲劳指数': 'Fatigue',
            '最小自由频率': 'Min Free Frequency',
            '最大自由频率': 'Max Free Frequency',
            '相对峰值平均值%': 'Relative Peak Avg Force%',
            '落地峰值': 'Landing Peak',
            '落地到恢复稳定时间': 'Restore Stabilization Time',
            '前后摇晃最大幅度': 'Longitudinally Max Shaking',
            '左右摇晃最大幅度': 'Lateral Max Shaking',
            '总体平均摇晃速度': 'Overall Avg Shaking Speed',
            '前后平均摇晃速度': 'Longitudinal Avg Shaking Speed',
            '左右平均摇晃速度': 'Lateral Avg Shaking Speed',
            '落地峰值力%': 'Landing Peak%',
            '落地恢复时间%': 'Landing Recovery Time%',
            '左右摇晃轨迹长度': 'Sway trajectory of left and right',
            '前后摇晃轨迹长度': 'Sway trajectory of back and forth',
            '总体摇晃轨迹长度': 'Overall sway trajectory',
            '轨迹包络面积': 'Trajectory envelope area',
            '最大净力值': 'Maximum Net Force',
            '发力率50ms': 'Force Rate 50ms',
            '发力率100ms': 'Force Rate 100ms',
            '发力率150ms': 'Force Rate 150ms',
            '发力率200ms': 'Force Rate 200ms',
            '发力率250ms': 'Force Rate 250ms',
            '发力率300ms': 'Force Rate 300ms',
            '腾空高度': 'Height',
            '上箱高度': 'Upper Box Height',
            '离心制动阶段发力率': 'Force rate in centrifugal braking phase',
            '离心制动阶段冲量': 'Centrifugal braking phase impulse',
            '落地稳定时间': 'Landing stability time',
            '下蹲深度': 'Squat depth',
            '下蹲平均速度': 'Average squat depth',
            '预拉伸增强百分比PSAP': 'Pre-stretch Reinforcement Percentage PSAPPSAP',
            '弹性指数ESI': 'Resilience Indicator ESI',
            '落地表现指数': 'Landing performance Indicator',
            '左侧跌落峰值力': 'Left side drop peak force',
            '右侧跌落峰值力': 'Right side drop peak force',
            '左侧跌落峰值力加载率': 'Left Drop Peak Force Loading Rate',
            '右侧跌落峰值力加载率': 'Right Drop Peak Force Loading Rate',
            '跌落峰值力发力率': 'Drop peak force force rate',
            '离心阶段冲量': 'Centrifugation stage impulse',
            '跌落峰值力到达时间': 'Drop peak force arrival time',
            '左侧跌落峰值力到达时间': 'Left Drop Peak Force Arrival Time',
            '右侧跌落峰值力到达时间': 'Right Drop Peak Force Arrival Time',
            '落地峰值力': 'Landing Peak',
            '落地峰值力加载率': 'Landing peak force loading rate',
            '落地峰值力到达时间': 'Landing Peak Force Arrival Time',
            '左侧落地峰值力': 'Left Landing Peak Force',
            '右侧落地峰值力': 'Right Landing Peak Force',
            '左侧落地峰值力加载率': 'Peak force loading rate on the left side',
            '右侧落地峰值力加载率': 'Peak force loading rate on the Right side',
            '左侧落地峰值力到达时间': 'Left Landing Peak Force Arrival Time',
            '右侧落地峰值力到达时间': 'Right Landing Peak Force Arrival Time',
            '触地时间差': 'Ground contact time difference',
            '落地顺序': 'Landing order',
            '平均下蹲速度': 'Average squat speed',
            '平均下蹲深度': 'Average squat depth',
            '缓冲最大相对力值': 'Buffer Max Relative Force',
            '蹬伸最大相对力值': 'Pedal Max Relative Force',
            '缓冲时间': 'Buffer Time',
            '下蹲速度': 'Squat speed',
            '蹬伸时刻': 'Pedal Time',
            '频率FRE': 'Frequency FRE',
            '初段平均频率FRE1': 'Initial Average Frequency FRE1',
            '中段平均频率FRE2': 'Middle Average Frequency FRE2',
            '末段平均频率FRE3': 'End Segment Average Frequency FRE3',
            '左右腿相对峰值平均值%': 'Left And Right Legs Relative Peak Avg Force%',
            '左右平均腿腾空时间%': 'Average Time Of Left And Right Legs In The Air%',
            '左右平均腿触地时间%': 'Average Left And Right Leg Contact Time%%',
            '左侧最大范围': 'Left maximum range',
            '左侧平均范围': 'Left average range',
            '右侧最大范围': 'Right maximum range',
            '右侧平均范围': 'Right average range',
            '最大范围BSA': 'Maximum range BSA',
            '最大范围':'maximum range',
            '平均范围':'average range',
            '峰值力':'Peak Force',
            '平均力':'Avg Force',
            '冲量I':'Impulse',
            '峰值力对称性%':'Peak Symmetry%',
            '最小力值对称性%':'Valley Symmetry%',
            '冲量对称性%':'Impulse Symmetry%'
        }
    },
    UserManagement: {
        Label: {
            Member: "Member",
            Disabled: "Disabled",
            SelectRole: "Role",
            SelectGroup: "Permission Group",
            FilterByAccountName: "Search by account or username",
            BatchOperate: "Batch",
            CreateAccount: "Create Account",
            Enanble: "Restore",
            Disable: "Disable",
            Delete: "Delete",
            Permission: "Permission",
            Information: "Information",
            Role: "Role",
            PermissionGroup: "Group",
            DefaultGroup: "Default Group",
            Account: "Account",
            Password: "Password",
            Name: "Name",
            ModifyPermission: "Modify Permission",
            ModifyAccountInfo: "Modify Information",
            Prev: "Prev",
            Next: "Next",
            CreateConfirm: "Create"
        },
        Columns: {
            AvatarAccount: "Avatar/Account",
            UserName: "Name",
            CreateTime: "Create Time",
            RolePermission: "Role/Permission",
            Operate: "Operate"
        },
        Message: {
            LengthNotice: 'Please enter 8 to 16 bits',
            AccountFillNotice: 'The account is in email format',
            ConfirmDisable: "Confirm to disable the account?",
            ConfirmEnable: "Confirm to restore the account?",
            ConfirmDelete: "Confirm to delete the account completely?",
            ConfirmPermissionModify: "Confirm to modify the account permissions?",
            ConfirmModifyAccountInfo: "Confirm to save?",
            PermissionModifySuccess: "The modification was successful.",
            PWNotice: 'The password cannot be empty',
            NameNotice: 'The name cannot be empty',
        }
    },
    Role: {
        0: "Athletes",
        1: 'Coaches',
        63: 'Administrator',
        127: 'O&M',
        255: 'Super Administrator',
        Subject: "Athletes",
        Coach: "Coaches",
        Admin: "Administrator",
        OM: "O&M",
    },
    Gender: {
        0: "Male",
        1: "Female"
    },
    ActionModel: {
        RecordCount: 'Record Count',
        ProjectCount: 'Project Count',
        Nordic: 'Nordic',
        Razor: 'Razor',
        IsometricContraction_0: '0° Isometric Contraction',
        IsometricContraction_30: '30° Isometric Contraction',
        IsometricContraction_60: '60° Isometric Contraction',
        Irons: "Irons",
        Woods: "Woods",
        Wedges: "Wedges",
        Hybrids: "Hybrids",
        Putter: "Putter",
        Iron1: "1 Iron",
        Iron2: "2 Iron",
        Iron3: "3 Iron",
        Iron4: "4 Iron",
        Iron5: "5 Iron",
        Iron6: "6 Iron",
        Iron7: "7 Iron",
        Iron8: "8 Iron",
        Iron9: "9 Iron",
        Iron10: "10 Iron",
        Driver: "Driver",
        Wood3: "3 Wood",
        Wood5: "5 Wood",
        Wood7: "7 Wood",
        Wood9: "9 Wood",
        Pitch: "Pitching Wedge",
        Wedge48: "48° Wedge",
        Wedge50: "50° Wedge",
        Wedge52: "52° Wedge",
        Wedge54: "54° Wedge",
        Wedge56: "56° Wedge",
        Wedge58: "58° Wedge",
        Wedge60: "60° Wedge",
        Wedge62: "62° Wedge",
        Hybrid1: "1 Hybrid",
        Hybrid2: "2 Hybrid",
        Hybrid3: "3 Hybrid",
        Hybrid4: "4 Hybrid",
        Hybrid5: "5 Hybrid",
        Hybrid6: "6 Hybrid",
        Hybrid7: "7 Hybrid",
        '1': 'Neck',
        '2': 'Forward Flexion',
        '3': 'Backward Extension',
        '4': 'Left Lateral Flexion',
        '5': 'Right Lateral Flexion',
        '6': 'Seated',
        '7': 'Seated',
        '8': 'Seated',
        '9': 'Seated',
        '10': 'Shoulder',
        '11': 'Left',
        '12': 'Right',
        '13': 'Internal Rotation',
        '14': 'External Rotation',
        '15': 'Adduction',
        '16': 'Abduction',
        '17': 'Flexion',
        '18': 'Extension',
        '19': 'ISO I Test',
        '20': 'ISO Y Test',
        '21': 'ISO T Test',
        '22': 'Seated - 90° Elbow Flexion',
        '23': 'Seated - 90° Elbow Flexion 90° Shoulder Abduction',
        '24': 'Standing - 90° Elbow Flexion',
        '25': 'Standing - 90° Elbow Flexion 90° Shoulder Abduction 90° Shoulder External Rotation',
        '26': 'Supine - 90° Elbow Flexion 90° Shoulder Abduction',
        '27': 'Supine - 90° Elbow Flexion',
        '28': 'Prone',
        '29': 'Seated - 90° Elbow Flexion',
        '30': 'Seated - 90° Elbow Flexion 90° Shoulder Abduction',
        '31': 'Standing - 90° Elbow Flexion',
        '32': 'Standing - 90° Elbow Flexion 90° Shoulder Abduction',
        '33': 'Supine - 90° Elbow Flexion 90° Shoulder Abduction',
        '34': 'Supine - 90° Elbow Flexion',
        '35': 'Prone',
        '36': 'Seated',
        '37': 'Standing',
        '38': 'Seated',
        '39': 'Standing',
        '40': 'Side Lying',
        '41': 'Seated - 90° Shoulder Abduction',
        '42': 'Standing',
        '43': 'Standing - 90° Elbow Flexion',
        '44': 'Seated',
        '45': 'Standing',
        '46': 'Seated - 90° Shoulder Flexion',
        '47': 'Standing - 90° Shoulder Flexion',
        '48': 'Supine',
        '49': 'Supine',
        '50': 'Prone',
        '51': 'Supine',
        '52': 'Prone',
        '53': 'Supine',
        '54': 'Prone',
        '55': 'Trunk',
        '56': 'Forward Flexion',
        '57': 'Left Lateral Flexion',
        '58': 'Right Lateral Flexion',
        '59': 'Seated',
        '60': 'Seated',
        '61': 'Seated',
        '62': 'Hip',
        '63': 'Left',
        '64': 'Right',
        '65': 'Flexion',
        '66': 'Extension',
        '67': 'Internal Rotation',
        '68': 'External Rotation',
        '69': 'Adduction',
        '70': 'Abduction',
        '71': 'Standing',
        '72': 'Prone',
        '73': 'Prone - 90° Knee Flexion',
        '74': 'Half Prone',
        '75': 'Standing',
        '76': 'Supine',
        '77': 'Seated',
        '78': 'Seated',
        '79': 'Supine',
        '80': 'Prone',
        '81': 'Seated',
        '82': 'Supine',
        '83': 'Prone',
        '84': 'Supine',
        '85': 'Supine - 45° Knee Flexion',
        '86': 'Supine - 90° Elbow Flexion',
        '87': 'Supine',
        '88': 'Supine - 45° Knee Flexion',
        '89': 'Supine - 90° Elbow Flexion',
        '90': 'Side Lying',
        '91': 'Elbow',
        '92': 'Left',
        '93': 'Right',
        '94': 'Flexion',
        '95': 'Extension',
        '96': 'Seated - 90° Elbow Flexion - Wrist Neutral',
        '97': 'Seated - 90° Elbow Flexion - Wrist Pronation',
        '98': 'Seated - 90° Elbow Flexion - Wrist Supination',
        '99': 'Seated - 90° Elbow Flexion 90° Shoulder Abduction - Wrist Neutral',
        '100': 'Seated - 90° Elbow Flexion 90° Shoulder Abduction - Wrist Pronation',
        '101': 'Standing - 90° Elbow Flexion - Wrist Neutral',
        '102': 'Seated - 90° Elbow Flexion',
        '103': 'Wrist',
        '104': 'Left',
        '105': 'Right',
        '106': 'Supination',
        '107': 'Pronation',
        '108': 'Flexion',
        '109': 'Extension',
        '110': 'Ulnar Deviation',
        '111': 'Radial Deviation',
        '112': '90° Elbow Flexion - Wrist Neutral',
        '113': '90° Elbow Flexion - Wrist Neutral',
        '114': '90° Elbow Flexion - Wrist Neutral',
        '115': '90° Elbow Flexion - Wrist Neutral',
        '116': '90° Elbow Flexion - Wrist Neutral',
        '117': '90° Elbow Flexion - Wrist Pronation',
        '118': '90° Elbow Flexion - Wrist Supination',
        '119': '90° Elbow Flexion - Wrist Neutral',
        '120': '90° Elbow Flexion - Wrist Pronation',
        '121': '90° Elbow Flexion - Wrist Supination',
        '122': 'Hand',
        '123': 'Left',
        '124': 'Right',
        '125': 'Grip Strength',
        '126': 'Seated - 90° Elbow Flexion - Wrist Neutral',
        '127': 'Seated - Wrist Neutral',
        '128': 'Seated - 90° Shoulder Flexion - Wrist Neutral',
        '129': 'Knee',
        '130': 'Left',
        '131': 'Right',
        '132': 'Flexion',
        '133': 'Extension',
        '134': 'Seated',
        '135': 'Prone',
        '136': 'Supine',
        '137': 'Seated - 90° Knee Flexion',
        '138': 'Prone - 90° Knee Flexion',
        '139': 'Supine',
        '140': 'Ankle',
        '141': 'Left',
        '142': 'Right',
        '143': 'Inversion',
        '144': 'Eversion',
        '145': 'Dorsiflexion',
        '146': 'Plantarflexion',
        '147': 'Straight Leg Sitting',
        '148': 'Straight Leg Sitting',
        '149': 'Straight Leg Sitting',
        '150': 'Straight Leg Sitting',
        '151': 'Foot',
        '152': 'Left',
        '153': 'Right',
        '154': 'Toe Flexion',
        '155': 'Toe Extension',
        '156': 'Seated',
        '157': 'Straight Leg Sitting - Plantarflexion',
        '158': 'Straight Leg Sitting - Neutral Plantar',
        '159': 'Seated',
        '160': 'Straight Leg Sitting - Neutral Plantar',
        '161': 'Straight Leg Sitting - Plantarflexion',
        '162': 'Standing',
        '163': 'Supine',
        '164': 'Standing',
        '165': 'Supine',
        '166': 'Standing',
        '167': 'Supine',
        '168': 'Standing',
        '169': 'Supine',
        '170': 'Side Lying',
        '171': 'Side Lying',
        '172': 'Scapular Elevation',
        '173': 'Scapular Protraction',
        '174': 'Scapular Retraction',
        '175': 'Seated',
        '176': 'Seated',
        '177': 'Seated',
        '178': 'Seated - 90° Elbow Flexion',
        '179': 'Standing - 90° Elbow Flexion',
        '180': 'Supine - 90° Elbow Flexion',
        '181': 'Seated - 90° Elbow Flexion',
        '182': 'Standing - 90° Elbow Flexion',
        '183': 'Prone',
        '184': 'Seated - 90° Shoulder Abduction',
        '185': 'Seated - 90° Shoulder Abduction 90° Elbow Flexion',
        '186': 'Seated - 90° Elbow Flexion',
        '187': 'Seated - 90° Shoulder Abduction 90° Elbow Flexion',
        '188': 'Standing - 90° Elbow Flexion',
        '189': 'Side Lying - 90° Elbow Flexion',
        '190': 'Seated - 90° Elbow Flexion 90° Shoulder Abduction 90° Shoulder External Rotation',
        '191': 'Seated - 90° Elbow Flexion 90° Shoulder Abduction 90° Shoulder External Rotation',
        '192': 'Side Lying - 90° Elbow Flexion',
        '193': 'Standing - 90° Elbow Flexion - Wrist Pronation',
        '194': 'Standing - 90° Elbow Flexion - Wrist Supination',
        '195': 'Standing - 90° Elbow Flexion',
        '197': 'Other',
        '198': 'Standing - 90° Knee Flexion',
        '199': 'Seated - 45° Knee Flexion',
        '200': 'Half Supine',
        '201': 'Prone - 45° Knee Flexion',
        '205': 'Mid-Thigh Pull',
        '206': 'Standing',
        '207': '90° Elbow Flexion - Wrist Supination',
        '208': '90° Elbow Flexion - Wrist Pronation',
        'Hip_Joint': 'Hip Joint',
        'Buckling': 'Flexion',
        'Stand_Straight': 'Standing - Straight Leg',
        'Stand_Knees_Kick': 'Standing - Knee Kick',
        'Stomach_Knees_30': 'Prone - 30° Knee Flexion',
        'Sit_Knees_90': 'Seated - 90° Knee Flexion',
        'Back_Knees_90': 'Supine - 90° Knee Flexion',
        'Spread': 'Extension',
        'Stomach_Knees_Thigh': 'Prone - 90° Knee Flexion - Thigh',
        'Stand_Upright_Ankle': 'Standing Upright - Ankle',
        'Adduction_Abduction': 'Adduction/Abduction',
        'Back_Knees_120': 'Supine - 120° Knee Flexion',
        'Back_Knees_135': 'Supine - 135° Knee Flexion',
        'Stance_Ankles': 'Standing - Ankles',
        'Standing_Knees': 'Standing - Knees',
        'Back_Ankles': 'Supine - Ankles',
        'Back_Knees': 'Supine - Knees',
        'Internal_External': 'Internal/External Rotation',
        'Stomach_Knees_90': 'Prone - 90° Knee Flexion',
        'Knee_Joint': 'Knee Joint',
        'Stomach_Knees_45': 'Prone - 45° Knee Flexion',
        'Stand_Knees_90': 'Standing - 90° Knee Flexion',
        'Back_Knees_45': 'Supine - 45° Knee Flexion',
        'Sit_Knees_10': 'Seated - 10° Knee Flexion',
        'Sit_Knees_45': 'Seated - 45° Knee Flexion',
        'Back_Knees_10': 'Supine - 10° Knee Flexion',
        'Ankle_Joint': 'Ankle Joint',
        'Dorsiflexion': 'Dorsiflexion',
        'Sitting_Position': 'Seated Position',
        'Varus_Valgus': 'Varus/Valgus',
        'Back_StraightLegs': 'Supine - Straight Legs',
        'Toe_Flexion': 'Toe Flexion',
        'Lie_Supine': 'Supine',
        'Shoulder_Joint': 'Shoulder Joint',
        'Stomach_Straight': 'Prone - Straight Arm',
        'Abduction': 'Abduction',
        'Side_Straight': 'Side Lying - Straight Arm',
        'Adduction': 'Adduction',
        'Shoulder_Elbow': 'Supine - 90° Shoulder Abduction 90° Elbow Flexion',
        'Elbow_Neutral': 'Supine - Neutral Position 90° Elbow Flexion',
        'Articulatio_Cubiti': 'Elbow Joint',
        'Sit_Elbows_90': 'Seated - 90° Elbow Flexion',
        'Neck': 'Neck',
        'Default_Position': 'Default Position',
        'Lateral_Flexion': 'Lateral Flexion',
        Default:'Default',
        Left: 'Left',
        Right: 'Right',
        Left_To_Right: 'Left then Right',
        Right_To_Left: 'Right then Left',
        simultaneously: 'Simultaneously',
        Null: 'None',
        'CMJ': 'Countermovement Jump',
        'SJ': 'Squat Jump',
        'DropJump': 'Drop Jump',
        'MVC': 'Maximum Voluntary Contraction',
        'RepetitiveHopping': 'Repetitive Hopping',
        'RepetitiveCMJ': 'Repetitive CMJ',
        'Squat': 'Squat',
        'Stamping': 'Stamping Test (Frequency & Endurance)',
        'Landing': 'Landing Test',
        'Balance': 'Balance Test',
        'AthleticShoulder': 'Athletic Shoulder Test',
        'Free': 'Free',
        'DJ': 'Depth Jump',
        'Inside': 'Adduction',
        'Outside': 'Abduction',
        '踝关节': 'Ankle',
        '肘关节': 'Elbow',
        '髋关节': 'Hip',
        '颈部': 'Neck',
        '肩关节': 'Shoulder',
        '躯干': 'Trunk',
        '膝关节': 'Knee',
        '腕关节': 'Wrist',
        '腕关节尺偏': 'Wrist Ulna Deviation',
        '髋关节外旋': 'Hip External Rotation',
        '髋关节内收': 'Hip Adduction',
        '髋关节外展': 'Hip Abduction',
        '颈部屈曲': 'Neck Flexion',
        '颈部伸展': 'Neck Extension',
        '颈部侧屈': 'Neck Lateral Flexion',
        '颈部旋转': 'Neck Rotation',
        '肩关节内旋': 'Shoulder Internal Rotation',
        '肩关节外旋': 'Shoulder External Rotation',
        '肩关节屈曲': 'Shoulder Flexion',
        '踝内翻': 'Ankle Inversion',
        '踝外翻': 'Ankle Eversion',
        '足背屈': 'Ankle Dorsiflexion',
        '足跖屈': 'Ankle Plantar Flexion',
        '肘伸展': 'Elbow Extension',
        '肘屈曲': 'Elbow Flexion',
        '髋关节伸展': 'Hip Extension',
        '髋关节屈曲': 'Hip Flexion',
        '髋关节内旋': 'Hip Internal Rotation',
        '肩关节外展': 'Shoulder Abduction',
        '躯干伸展': 'Trunk Extension',
        '躯干侧屈': 'Trunk Lateral Flexion',
        '膝关节屈曲': 'Knee Flexion',
        '膝关节伸展': 'Knee Extension',
        '腕关节桡偏': 'Wrist Radial Deviation',
        '肩关节水平内收': 'Shoulder Horizontal Adduction',
        '肩关节水平外展': 'Shoulder Horizontal Abduction',
        '肩关节伸展': 'Shoulder Extension',
        '躯干屈曲': 'Trunk Flexion',
        '躯干旋转': 'Trunk Rotation',
        '腕关节旋前': 'Wrist Pronation',
        '肩关节内收': 'Shoulder Adduction',
        '腕关节旋后': 'Wrist Supination',
        '腕关节屈曲': 'Wrist Flexion',
        '腕关节伸展': 'Wrist Extension',
        '仰卧位': 'Supine',
        '仰卧位（直腿）': 'Supine (Long Lever)',
        '仰卧位（肘屈曲 90°）': 'Supine 90° Elbow Flexion',
        '仰卧位（肩外展 90° - 肘屈曲 90°）': 'Supine 90° Shoulder Abduction 90° Elbow Flexion',
        '侧卧位': 'Side Lying',
        '俯卧位': 'Prone',
        '俯卧位（肩外展 90° - 肘屈曲 90°）': 'Prone 90° Shoulder Abduction, 90° Elbow Flexion',
        '半跪姿': 'Half Kneeling',
        '坐位': 'Sitting',
        '坐位（肘屈曲 90°）': 'Sitting 90° Elbow Flexion',
        '坐位（肩外展 90° - 肘屈曲 90°）': 'Sitting 90° Shoulder Abduction 90° Elbow Flexion',
        '站立位': 'Standing',
        '站立位（肘屈曲 90°）': 'Standing 90° Elbow Flexion',
        '站立位（肩外展 90° - 肘屈曲 90°）': 'Standing 90° Shoulder Abduction 90° Elbow Flexion',
        '肘屈曲90°': '90° Elbow Flexion',
        '长坐位（无跖屈）': 'Long Sitting - Plantigrade',
        '长坐位（跖屈）': 'Long Sitting - Plantar Flexed'
    },
    StandardData: {
        Title: "Standard Value Management(Muscle Strength)",
        Assembly: "Combinations of actions",
        Limbs: 'Limbs',
        Actions: 'Actions',
        Pose: 'Poses',
        Gender: 'Gender',
        Age: 'Age',
        PeakForce: 'Peak Force N/kg',
        Modify: 'Set the standard value',
        FileBrowsing: 'File Browsing',
        FileRequired: 'Please select the file you want to import',
        DropFileHere: 'Drop file here',
        clickToUpload: 'click to upload',
        SportTitle: 'Standard Value Management(Sport performance test system)',
        Mean: 'Mean',
        Outstanding: 'Outstanding',
        '青少年': 'Teenager',
        '18~30': '18~30',
        '31~45': '31~45',
        '46~60': '46~60',
        'AgeGroup': 'Age Group',
        ModifySuccess: 'Modified Successfully',
        ErrorRaw: 'Error line',
        ErrorInfo: 'Error message',
        ErrorCount: 'Number of errors',
        Sure: 'Sure',
        ErrorStatistics: 'Error Statistics',
        EmptyId: 'Id cannot be empty',
        IdParseError: 'Invalid Id',
        EmptyValue: 'The standard value cannot be empty',
        InvalidId: 'Invalid Id',
        ValueParseError: 'Invalid standard value'
    },
    Project: {
        Public: 'Public',
        Private: 'Private',
        Title: 'Test Project',
        FilterName: 'Search by Project Name',
        FilterSubject: 'Search by Subject Name',
        Columns: {
            CreateTime: 'Creation Time',
            ProjectName: 'Project Name',
            CreatorName: 'Creator',
            Operate: 'Operations',
            Name: 'Name',
            Gender: 'Gender',
            Age: 'Age',
            SubjectName: 'Subject',
            Model: 'Test Movement'
        },
        Skipped: 'Skipped',
        RecordView: 'Records',
        Batch: 'Batch Operations',
        BatchDelete: 'Batch Delete',
        DeleteEmptyNotice: 'Please select the content to delete',
        Finish: 'Complete',
        Create: 'Create Test Project',
        View: 'Test Project',
        ProjectName: 'Project Name',
        Subjects: 'Subjects',
        AddSubject: 'Add Subject',
        PublicProject: 'Public Project',
        PrivateProject: 'Private Project',
        ProjectType: 'Project Type',
        CreateTime: 'Creation Time',
        CreateProject: 'Create Project',
        Save: 'Save Changes',
        ProjectSubjectList: 'Project Subjects',
        NameFilter: 'Name Search',
        CreateSuccess: 'Created Successfully',
        ModifySuccess: 'Modified Successfully',
        DeleteSuccess: 'Deleted Successfully',
        DeleteFailed: 'Delete Failed',
        NameTooLong: 'Name too long (max 24 characters)',
        RequireName: 'Project name required',
        SubjectManagerment: 'Subject Management',
        Added: 'Added',
        DeleteConfirm: 'Deleting project will also delete related test records. Continue?',
        ConfirmToDeleteRow: 'Confirm to delete this record?',
        ConfromToDeleteSubjetc: 'Will the cancellation of the subject delete the relevant test records at the same time, confirm that you want to continue?',
        DoNotAskAgain: 'No more prompts'
    },
    TrainingPlan: {
        Title: 'Training Plan',
        PlanType: 'Type',
        Public: 'Public',
        Private: 'Private',
        PlanName: 'Plan Name',
        Columns: {
            CreateTime: 'Creation Time',
            PlanName: 'Plan Name',
            CreatorName: 'Creator',
            Operate: 'Operations',
            ActionCount: 'Movement Count',
            Seq: 'Sequence',
            Action: 'Movement',
            ActionTimes: 'Repetitions',
            SubjectName: 'Subject Name',
            Completeness: 'Completion',
            UsedTimes: 'Test Count',
            Model: 'Test Movement',
            Gender: 'Gender'
        },
        RecordView: 'Records',
        Batch: 'Batch Operations',
        BatchDelete: 'Batch Delete',
        Finish: 'Complete',
        Create: 'Create Training Plan',
        Modify: 'Modify',
        Actions: 'Movements',
        Subjects: 'Subjects',
        Records: 'Test Records',
        Statue: 'Completion Status',
        Finished: 'Completed',
        Unfinish: 'Incomplete',
        FilterName: 'Search by Plan Name',
        RequireName: 'Plan name required',
        NameTooLong: 'Name too long (max 50 characters)',
        deleteRecord: 'Delete Record',
        DeleteConfirm: 'This will also delete related test records. Continue?',
        AddAction: 'Add Movement',
        TestActions: 'Test Movements',
        CreatePlan: 'Create Training Plan',
        SavePlan: 'Save Training Plan',
        Action: 'Movement',
        Times: 'Repetitions',
        ActionAssembly: 'Movement Combination',
        RequireAssembly: 'Select movements',
        ConfirmDeleteAction: 'Confirm to delete movement?'
    },
    DefaultGroup: "Default",
    Empty_PhoneNumber: "Please enter your mobile phone number",
    Duplicate_PhoneNumber: "The mobile phone number is duplicated and cannot be bound again",
    Invalid_BOMType: "The mod type doesn't exist!",
    InsertFailed_Assembly: "Failed to add a new action!",
    Invalid_BOM: "Mods don't exist!",
    InsertFailed_BOM: "Failed to add the mod!",
    UpdateFailed_BOM: "Failed to modify the mod!",
    DeleteFailed_BOM: "Failed to delete the mod!",
    Invalid_Project: "The project does not exist!",
    Invalid_Subject: "The subject does not exist!",
    Exsist_Account: "The account already exists!",
    Invalid_Account: "The account does not exist!",
    Incorrect_OldPassword: "The old password is incorrect!",
    Invalid_Company: "The company could not be found!",
    Invalid_CompanyID: "Invalid company code!",
    Incorrect_ApplicationCode: "Invalid app code!",
    Incorrect_AccountOrPassword: "Wrong username or password!",
    Expired_Captcha: "The verification code has expired!",
    Incorrect_Captcha: "The verification code is incorrect!",
    Failed_SendCaptcha: "The verification code failed to be sent!",
    Invalid_Captcha: "Invalid verification code!",
    Empty_SubjectName: "Please enter the name of the subject!",
    Repeat_SubjectName: "Athletes with the same name already exist!",
    Duplicate_Requests: "The request is too frequent, please try again later",
    UnknownError_Account: "The current user does not exist!",
    Locked_Company: "The organization/company is locked!",
    Expired_Authorization: "The organization/company app authorization has expired!",
    Invalid_Authorization: "The organization/company application authorization is not enabled!",
    Invalid_Parameter: "Invalid arguments!",
    Invalid_License: "The license is invalid!",
    Binded_License: "The license is already bound to another device!",
    Unbind_License: "The license is not yet bound!",
    Expired_License: "The license has expired!",
    Failed_License: "License validation failed!",
    Empty_ApplictionCode: "The app ID is missing!",
    Invalid_ApplictionCode: "The app number is invalid!",
    Invalid_ApplictionEndPoint: "Invalid system node",
    Older_Version: "Older version numbers",
    Empty_Version: "There is no valid version number",
    Duplicate_ApplicationCode: "Duplicate system identifiers",
    Invalid_Application: "Ineffective test system",
    Empty_Upgrade: "Please select the file you want to update",
    Invalid_Version: "Invalid version number",
    Invalid_Record: "Invalid records",
    NotFound_Record: "No data records found",
    Failed_ResetPassword: "Failed to reset password",
    Incomplete_Infomation: "The input information is incomplete",
    Invalid_Binded: "Invalid binding records",
    ParallelLimit_License: "The maximum number of bindings is exceeded",
    Exsist_PermissionGroup: "A permission group already exists",
    Invalid_PermissionDenied: "Insufficient permissions",
    Invalid_PermissionGroup: "Invalid role permissions",
    Duplicate_Project: "Duplicate test items",
    Duplicate_SportProject: "Sports item name cannot be duplicated",
    Invalid_SportProject: "Ineffective sports",
    Invalid_File: "The file does not exist!",
    UploadFailed_NoFile: "There are no files to upload!",
    DownloadFailed_NoFile: "File not found!",
    Incorrect_Format: "The data is not in the correct format",
    UploadFailed_Timeout: "Upload timed out!",
    DownloadFailed_Timeout: "Download timed out!",
    Repeat_Name: "There is already a user with the same name",
    Empty_Account: "Please enter your account",
    Empty_Password: "Please enter your password",
    Empty_Name: "Please enter a name",
    Invationing_SubjectEmail: 'The mailbox is being invited',
    Invationing_SubjectName: 'The names of athletes are being invited',
    Invalid_InvationLink: 'The link is invalid',
    Submit_SubjectInfo: 'The athlete has submitted information',
    Incorrect_Subject: 'Athletes do not exist',
    Incomplete_InvationCode: 'Missing invitation code',
    Duplicate_Subject: 'The athlete name already exists',
    Duplicate_InvationEmail: 'Invitations cannot be sent to the same email address within 5 minutes!',
    Invalid_RecordSide: 'Invalid order',
    NotBe_SameDay: "Selected dates must be the same day",
    Invalid_Indicator: "Invalid indicator",
    Invalid_UserName: "User nickname cannot be empty",
    UnUpload_SubjectOrProject: "Test item or subject not uploaded",
    UnUpload_Subject: "Subject not uploaded",
    Duplicate_SubjectName: "Duplicate subject name",
    SyncData: "Please sync data first",
    Duplicate_TrainingPlanName: "Duplicate training plan name",
    Invalid_TrainingPlan: "Invalid training plan",
    Invalid_Key: "Invalid key",
    Failed_CallService: "Service call failed",
    FileNotExist: 'File Not Exists',
    Repeat_ProjectName: 'Project Name Repeat'
}